import React, { useEffect, useState } from "react";
import Breadcrumbs from "common/Breadcrumbs/Breadcrumbs";
import { P } from "common/P/P";
import { routeConstants } from "navigation/routeConstants";
import { Button } from "common/Button/Button";
import { ReactComponent as AddLetterIcon } from "common/assets/icons/add-page.svg";
import Pagination from "components/Pagination/Pagination";
import CommandmentsTable from "components/CommandmentsTable/CommandmentsTable";
import axios from "axios";
import { serviceConfig } from "configs";
import FileUpload from "common/FileUpload/FileUpload";
import Modal from "common/Modal/Modal";
import { Input } from "common/Input/Input";
import DatePicker from "common/DatePicker/DatePicker";
import { Select } from "common/Select/Select";
import { SelectItem } from "common/Select/SelectItem";
import { ReactComponent as LangIcon } from "common/assets/flags/tk.svg";
import { ReactComponent as ThemeIcon } from "common/assets/icons/moon-stars.svg";
import { ReactComponent as NotificationIcon } from "common/assets/icons/bell.svg";
import { ReactComponent as AvatarIcon } from "common/assets/icons/user.svg";
import MultiSelect from "common/MultiSelect/MultiSelect";

const breadcrumbItems = [
	{ label: "Buýruklar", path: routeConstants.root.route },
	{ label: "Meniň buýruklarym " },
];

const MyCommandmentsPage: React.FC = (): JSX.Element => {
	const userString = localStorage.getItem("user");
	const user = userString ? JSON.parse(userString) : null;

	const userId = user ? user?.user?._id : null; // Replace with actual user ID
	const userTypeId = user ? user?.user.userTypeId?._id : null;
	const numericUserTypeId = parseInt(userTypeId);
	const [currentPage, setCurrentPage] = useState(1);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [commands, setCommands] = useState([]);
	const [haveToCommands, setHaveToCommands] = useState([]);
	const [completedCommands, setCompletedCommands] = useState([]);
	const [totalPages, setTotalPages] = useState(0);

	const [currentView, setCurrentView] = useState("all");
	const [formData, setFormData] = useState<any>({
		commandName: "",
		currentUserId: "",
		sendingUserId: userId,
		date: "",
		note: "",
		files: [],
	});
	const [sendTargets, setSendTargets] = useState<any>([]);

	const [selectedUserLabel, setSelectedUserLabel] = useState<any>("");
	const [selectedUsers, setSelectedUsers] = useState<any>([]);

	const itemsPerPage = 10;

	const openModal = () => setIsModalOpen(true);
	const closeModal = () => setIsModalOpen(false);

	useEffect(() => {
		const fetchSendTargets = async () => {
			try {
				const response = await fetch(
					`${serviceConfig.apiUrl}/send-targets/${numericUserTypeId}`
				);
				const data = await response.json();
				// Format the options for the MultiSelect component
				const formattedOptions = data.map((user: any) => ({
					value: user._id,
					label: `${user.name} ${user.sirname}`,
				}));

				setSendTargets(formattedOptions);
			} catch (error) {
				console.error("Error fetching send targets:", error);
			}
		};
		fetchSendTargets();
	}, []);

	useEffect(() => {
		fetchAllCommands();
		fetchCommandsByStatus();
		fetchCompletedCommands();
	}, []);

	const fetchAllCommands = async () => {
		try {
			const response = await axios.get(
				`${serviceConfig.apiUrl}/user-commands-all/${userId}`
			);
			setCommands(response.data);
		} catch (error) {
			console.error("Error fetching all commands:", error);
		}
	};

	const fetchCommandsByStatus = async () => {
		try {
			const response = await axios.get(
				`${serviceConfig.apiUrl}/user-commands-status/${userId}`
			);
			setHaveToCommands(response.data);
		} catch (error) {
			console.error("Error fetching commands by status:", error);
		}
	};

	const fetchCompletedCommands = async () => {
		try {
			const response = await axios.get(
				`${serviceConfig.apiUrl}/user-completed-commands/${userId}`
			);
			setCompletedCommands(response.data);
		} catch (error) {
			console.error("Error fetching completed commands:", error);
		}
	};

	const getCurrentData = () => {
		let data: any;
		switch (currentView) {
			case "all":
				data = commands;
				break;
			case "haveTo":
				data = haveToCommands;
				break;
			case "done":
				// Extracting the 'letterId' details for 'recent' and 'status' tabs
				data = completedCommands;
				break;
			default:
				data = [];
		}
		return data.slice(
			(currentPage - 1) * itemsPerPage,
			currentPage * itemsPerPage
		);
	};

	const currentOrders = getCurrentData();

	const handleInputChange = (e: any) => {
		const { name, value, type, checked } = e.target;

		if (type === "radio" && checked) {
			setFormData((prevState: any) => ({ ...prevState, [name]: value }));
		} else if (type !== "radio") {
			setFormData((prevState: any) => ({ ...prevState, [name]: value }));
		}
	};

	// const handleSelect = (userId: string) => {
	// 	setFormData((prevState: any) => ({
	// 		...prevState,
	// 		currentUserId: userId,
	// 	}));
	// 	const selectedUser = sendTargets.find((user: any) => user._id === userId);
	// 	if (selectedUser) {
	// 		setSelectedUserLabel(`${selectedUser.name} ${selectedUser.sirname}`);
	// 	}
	// };

	const handleMultiSelect = (selectedValues: any) => {
		// selectedValues is expected to be an array of selected user IDs
		setSelectedUsers(selectedValues);
		// If you need to set formData as well, you can update it here
		setFormData((prevState: any) => ({
			...prevState,
			currentUserId: selectedValues,
		}));
	};

	const handleFileChange = (e: any) => {
		if (e.target.files) {
			const filesArray = Array.from(e.target.files);
			setFormData((prevState: any) => ({
				...prevState,
				files: filesArray,
			}));
		}
	};

	const handleDateChange = (name: string, date: string) => {
		setFormData((prevState: any) => ({ ...prevState, [name]: date }));
	};

	const handleRowClick = (item: any) => {
		console.log("OPENED");
		// navigate(`/account/data/${order._id}`);
	};

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();

		const data = new FormData();
		Object.keys(formData).forEach((key) => {
			if (key === "files") {
				formData[key].forEach((file: File) => {
					data.append("files", file);
				});
			} else {
				if (key === "currentUserId") {
					data.append(key, JSON.stringify(formData[key]));
				} else {
					data.append(key, formData[key]);
				}
			}
		});

		try {
			const response = await axios.post(
				`${serviceConfig.apiUrl}/create-command`,
				data,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
				}
			);
			setFormData({
				commandName: "",
				currentUserId: "",
				date: "",
				note: "",
				files: [],
			});

			closeModal();
			window.location.reload();
		} catch (error) {
			console.error("Error submitting form:", error);
		}
	};

	const handleTabChange = (view: any) => {
		setCurrentView(view);
		switch (view) {
			case "all":
				setTotalPages(Math.ceil(commands.length / itemsPerPage));
				break;
			case "haveTo":
				setTotalPages(Math.ceil(haveToCommands.length / itemsPerPage));
				break;
			case "done":
				setTotalPages(Math.ceil(completedCommands.length / itemsPerPage));
				break;
			default:
				break;
		}
	};

	const getDataLength = () => {
		switch (currentView) {
			case "all":
				return commands.length;
			case "haveTo":
				return haveToCommands.length;
			case "done":
				return completedCommands.length;
			default:
				return 0;
		}
	};

	return (
		<div className="grid grid-cols-1 gap-4">
			<div className="grid grid-cols-1 gap-4 px-6 py-3 place-items-end">
				{/* <LangIcon />
					<ThemeIcon />
					<div className="relative">
						<NotificationIcon />
						<div className="absolute top-[-5px] right-[-5px] grid px-[0.4rem] py-[0.1rem] rounded-full place-items-center place-content-center bg-redColor">
							<P size="t2" type="semibold" className="text-white">
								4
							</P>
						</div>
					</div> */}
				<div className="grid gap-3 grid-cols-maxTwo place-items-center">
					<div className="p-2 rounded-full bg-grayOne">
						<AvatarIcon />
					</div>
					<div className="grid">
						<P size="t1" type="medium">
							{user ? `${user.user.name.charAt(0)}.${user.user.sirname}` : ""}
						</P>
						<P size="t2" type="regular" className="text-grayTwo">
							{user ? user.user.userTypeId?.positionName : ""}
						</P>
					</div>
				</div>
			</div>
			<div className="grid grid-flow-row auto-rows-max pb-7 gap-6 px-6 min-h-[90vh]">
				<Breadcrumbs items={breadcrumbItems} />
				<div className="grid grid-cols-maxTwo place-content-between place-items-center">
					<div className="grid grid-cols-maxThree h-max">
						<div
							className={`min-w-[88px] text-center px-4 py-2 ${
								currentView === "all"
									? "border rounded-l-md border-mainColor bg-mainGradient"
									: "border rounded-l-md border-mainColor bg-white"
							} cursor-pointer`}
							onClick={() => handleTabChange("all")}
						>
							<P
								size="p3"
								type="medium"
								className={`${
									currentView === "all" ? "text-white" : "text-mainColor"
								} cursor-pointer`}
							>
								Hemmesi ({commands.length})
							</P>
						</div>
						<div
							className={`min-w-[88px] text-center px-4 py-2 ${
								currentView === "haveTo"
									? "bg-mainGradient border-y border-mainColor"
									: "bg-white border-y border-mainColor"
							}  cursor-pointer`}
							onClick={() => handleTabChange("haveTo")}
						>
							<P
								size="p3"
								type="medium"
								className={`cursor-pointer ${
									currentView === "haveTo" ? "text-white" : "text-mainColor"
								} `}
							>
								Ýerine ýetirilmeliler
							</P>
						</div>
						<div
							className={`min-w-[88px] text-center px-4 py-2 ${
								currentView === "done"
									? "bg-mainGradient border rounded-r-md border-mainColor"
									: "bg-white border rounded-r-md border-mainColor"
							} cursor-pointer`}
							onClick={() => handleTabChange("done")}
						>
							<P
								size="p3"
								type="medium"
								className={`cursor-pointer ${
									currentView === "done" ? "text-white" : "text-mainColor"
								}`}
							>
								Ýerine ýetirilenler
							</P>
						</div>
					</div>
					<Button
						appearance="main"
						paddingY="py-2"
						className="h-max"
						onClick={openModal}
					>
						Buýruk ibermek
					</Button>
				</div>
				<Modal isOpen={isModalOpen} onClose={closeModal} title="Buýruk ibermek">
					<div className="grid grid-flow-row grid-cols-1 gap-6 auto-rows-max">
						<Input
							appearance="default"
							type="text"
							name="commandName"
							withlabel={true}
							label="Buýrugyň ady"
							value={formData.commandName}
							onChange={handleInputChange}
						/>

						<div className="grid grid-cols-1 gap-4 place-items-center">
							<MultiSelect
								label="Kabul ediji"
								options={sendTargets} // Use the formatted options directly
								value={selectedUsers}
								onSelect={handleMultiSelect}
							/>
						</div>

						<div className="grid grid-cols-1 gap-4 place-items-center">
							<DatePicker
								label="Ýerine ýetirilmeli senesi"
								onDateChange={(date) => handleDateChange("date", date)}
							/>
						</div>

						<div className="grid grid-cols-1">
							<Input
								appearance="default"
								type="text"
								name="note"
								withlabel={true}
								label="Bellik"
								value={formData.note}
								onChange={handleInputChange}
							/>
						</div>
						<div className="grid grid-cols-1">
							<FileUpload files={formData.files} onChange={handleFileChange} />
						</div>
						<Button
							appearance="main"
							className="place-self-end"
							paddingX="px-5"
							paddingY="py-[10px]"
							onClick={handleSubmit}
						>
							Ibermek
						</Button>
					</div>
				</Modal>
				<div>
					<CommandmentsTable data={currentOrders} onRowClick={handleRowClick} />
					<div className="grid grid-cols-maxTwo place-content-between place-items-center py-[14px] px-[20px] border-x border-b border-strokeColor rounded-b-md">
						<P size="t2" type="regular" className="text-grayTwo">
							Jemi {getDataLength()} sany
						</P>
						<Pagination
							currentPage={currentPage}
							totalPages={totalPages}
							onPageChange={setCurrentPage}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default MyCommandmentsPage;
